var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import { ModalStyle } from "../utils/constraints";
import { useLocalStorage } from "../utils/hooks";
export var ElfsightPopup = function (_a) {
    var trigger = _a.trigger, ID = _a.ID;
    return React.createElement(React.Fragment, null,
        trigger && React.createElement("div", { key: ID, id: trigger }),
        React.createElement("div", { className: "elfsight-app-".concat(ID) }));
};
export var Modal = function (_a) {
    var children = _a.children, _b = _a.style, style = _b === void 0 ? {} : _b, dismiss = _a.dismiss, _c = _a.dismissHTML, dismissHTML = _c === void 0 ? null : _c, dismissStyle = _a.dismissStyle;
    return React.createElement("div", { className: "tk-modal-backdrop", style: ModalStyle.main },
        React.createElement("div", { className: "tk-modal-container", style: __assign(__assign({}, ModalStyle.container), style) },
            children,
            React.createElement("a", { className: "tk-modal-close", style: __assign(__assign({}, ModalStyle.closeModal), dismissStyle), onClick: dismiss }, dismissHTML)));
};
export var DisplayOnce = function (_a) {
    var id = _a.id, children = _a.children, rest = __rest(_a, ["id", "children"]);
    var _b = useLocalStorage("displayOnce-".concat(id)), isDisplayed = _b[0], setIsDisplayed = _b[1];
    if (!isDisplayed) {
        return React.createElement(Modal, __assign({}, rest, { key: "".concat(id, "-modal"), dismiss: function () { return setIsDisplayed(true); } }), children);
    }
    else {
        return null;
    }
};
export var DisplayAlways = function (_a) {
    var id = _a.id, children = _a.children, rest = __rest(_a, ["id", "children"]);
    var _b = useState(false), isDisplayed = _b[0], setIsDisplayed = _b[1];
    if (!isDisplayed) {
        return React.createElement(Modal, __assign({}, rest, { key: "".concat(id, "-modal"), dismiss: function () { return setIsDisplayed(true); } }), children);
    }
    else {
        return null;
    }
};
export var ModalWrapper = function (_a) {
    var children = _a.children, _b = _a.wrapperStyle, wrapperStyle = _b === void 0 ? {} : _b;
    var style = __assign({ padding: "30px 30px 24px 30px", borderRadius: "12px", backgroundColor: "#7536f0", position: "relative" }, wrapperStyle);
    return React.createElement("div", { className: "tk-modal-wrapper", style: style },
        " ",
        children,
        " ");
};
//# sourceMappingURL=Popups.js.map